// extracted by mini-css-extract-plugin
export default {"spinViewIcon":"_35CM8","spinViewIconWithFeatured":"_1ujR8"};